/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約月別使用量
 */
export interface Sgkb575aResCtrMonthlyusage {
    /** 
     * 使用量種別コード：半角英数混在
     */
    empamtClscode?: string;
    /** 
     * 使用量種別コード名称：全角半角混在
     */
    empamtClsfyCodeaname?: string;
    /** 
     * 検針年月：日付YYYYMM
     */
    inspectionyearmonthday?: string;
    /** 
     * 使用量：半角数値(小数点なし)
     */
    elecCsp?: number;
}
